<script setup lang="ts">
import {computed} from "vue";

interface Props {
    label?: string
    modelValue: string | null
    type?: 'email' | 'text' | 'password'
    placeholder?: string
    required?: boolean
    details?: string
    autocomplete?: string
    autofocus?: boolean
    hideRequiredAsterisk?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    label: undefined,
    type: 'text',
    placeholder: undefined,
    required: false,
    details: undefined,
    autocomplete: undefined,
    autofocus: false,
    hideRequiredAsterisk: false,
})
const emit = defineEmits(['update:modelValue'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})
</script>

<template>
    <div class="d-flex justify-space-between align-center">
        <slot name="label">
            <label class="black--text text-body-2">{{ label }} <span
                v-if="required && !hideRequiredAsterisk"
                class="text-error font-weight-bold"
            >*</span></label>
        </slot>
        <slot name="link" />
    </div>
    <v-text-field
        v-model="value"
        class="mt-2 mb-5"
        density="compact"
        variant="outlined"
        color="blue"
        bg-color="white"
        rounded="lg"
        :placeholder="placeholder"
        :hide-details="details === undefined"
        :type="type"
        :autocomplete="autocomplete"
        :autofocus="autofocus"
        :required="required"
    >
        <template #details>
            <div class="text-disabled">
                {{ details }}
            </div>
        </template>
    </v-text-field>
</template>

<style scoped>

</style>
